import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { RevealLines } from "@/components/motion";

const QUOTES = [
  {
    q: "Aurelume didn't just redesign our brand — they gave it a soul. Our market perception shifted overnight.",
    name: "Ananya Rao",
    role: "Founder, Rao Wellness",
  },
  {
    q: "Strategic, bold and relentlessly detail-obsessed. They made our institution finally feel believed.",
    name: "Vikram Shetty",
    role: "Director, Meridian Group",
  },
  {
    q: "The most thoughtful branding partners we've worked with. Every touchpoint feels intentional and premium.",
    name: "Sara Menon",
    role: "CMO, Lumine Retail",
  },
];

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = QUOTES[i];
  const go = (d) => setI((p) => (p + d + QUOTES.length) % QUOTES.length);

  return (
    <section className="py-28 md:py-40 bg-[#F3EFE6]" data-testid="testimonials">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-12">
          — Believed by many
        </p>
        <div className="font-serif text-[#C5A059] text-8xl leading-none mb-2 select-none">
          &ldquo;
        </div>
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={i}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.6 }}
            data-testid="testimonial-quote"
            className="font-serif font-light text-3xl md:text-5xl leading-tight tracking-tight text-[#1A1713]"
          >
            {t.q}
          </motion.blockquote>
        </AnimatePresence>

        <div className="flex items-center justify-between mt-14 border-t border-[#E8E4D9] pt-8">
          <div>
            <p className="font-medium">{t.name}</p>
            <p className="text-sm text-[#78716C]">{t.role}</p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => go(-1)}
              data-testid="testimonial-prev"
              className="w-12 h-12 border border-[#1A1713] flex items-center justify-center hover:bg-[#1A1713] hover:text-[#FDFBF7] transition-colors"
            >
              <ArrowLeft size={18} />
            </button>
            <button
              onClick={() => go(1)}
              data-testid="testimonial-next"
              className="w-12 h-12 border border-[#1A1713] flex items-center justify-center hover:bg-[#1A1713] hover:text-[#FDFBF7] transition-colors"
            >
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
